var firstLoad = true;
var flagClickSearchWaiting = false;

Vue.component('search', {
  template: '#vue-search',
  data: function () {
    return {
      params: {
        type: 'default',
        destination: 'default',
        city: (config['components']['search']['cityAs'] == 'select' ? 'default' : ''),
        adults: 2,
        childrens: 0,
        start_date: convertDate(new Date().toISOString()),
        end_date: convertDate(new Date().toISOString()),
        transport: 'default',
        mw: 'default',
        alimentation: 'default',
        age_child_1: 'default',
        age_child_2: 'default',
        age_child_3: 'default',
        age_child_4: 'default',
        attributes: [],
        stars: 'default',
        days: '',
        daysText: '',
        discount: 'default',
        hotel_name: '',
        sort_order: 'default',
        lastKeySeen: '',
        allIdChecked: ''
      },
      config: {
        limit: 0,
        offset: 0,
        showAdvanced: false,
        showMw: true,
        types: [],
        destinations: [],
        cities: [],
        adults: [],
        childrens: [],
        transport: [],
        mw: [],
        alimentation: [],
        age_child_1: [],
        age_child_2: [],
        age_child_3: [],
        age_child_4: [],
        attributes: [],
        stars: [],
        days: [],
        discount: [
          { text: "Last Minute", value: "lm" },
          { text: "First Minute", value: "fm" },
          { text: "Promocja", value: "po" }
          // { text: "Wyróżnione oferty", value: "po" }
        ],
        show: {
          type: false,
          destination: false,
          destination_city: false,
          adults: false,
          childrens: false,
          start_date: false,
          end_date: false,
          transport: false,
          mw: false,
          alimentation: false,
          age_child_1: false,
          age_child_2: false,
          age_child_3: false,
          age_child_4: false,
          attributes: false,
          stars: false,
          days: false,
          discount: false,
          hotel_name: false
        },
        hotelNames: []
      },
      tmp: {
        destinationsAndCities: []
      }
    }
  },
  // created: function () {
  //     if (config['components']['search']['cityAs'] == 'select') {
  //         this.params.city = 'default';
  //     }
  // },
  mounted: function () {
    const self = this;

    serverBus.$on('search_change_params', function (data) {
      self.changeParams(data);
      self.clickSearch(false);
    });
    serverBus.$on('search_change_order', function (data) {
      self.changeParams(data);
      self.clickSearch(false);
    });
    serverBus.$on('search_more', function () {
      self.moreOffers();
    });

    self.refreshSearch();
  },
  beforeDestroy: function () {
    serverBus.$off('search_more');
  },
  watch: {
    'params.type': function (newType, oldType) {
      const self = this;
      if (oldType != '' && !firstLoad) {
        self.clickSearch(true);
      }
    },
    'params.destination': function (newType, oldType) {
      if (oldType != '') {
        if (this.config.show['destination_city']) this.changeCities(newType);
      }
    },
    'params.childrens': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.showSelectAgeChildrens(newValue);
      }
    },
    'params.start_date': function (newValue, oldValue) {
      $("input#start_date").datepicker("update", newValue);
    },
    'params.end_date': function (newValue, oldValue) {
      $("input#end_date").datepicker("update", newValue);
    }
  },
  methods: {
    changeTitleAndDescription: function () {
      const self = this;

      let paramsType = '';
      if (self.params.type && self.params.type != 'default') {
        // konkretny typ
        if (typeof self.config.types !== "undefined" && self.config.types.length > 0) {
          for (let i = 0; i < self.config.types.length; i++) {
            if (self.config.types[i].value == self.params.type) {
              paramsType = self.config.types[i].text;
              break;
            }
          }
        }
        if (!paramsType) paramsType = self.params.type;
        paramsType += ' w ';

      } else {
        // wszystkie typy
        paramsType = self.getTextsFromConfig('types')
        if (paramsType) paramsType += ' w ';
      }

      // title
      let newTitle = '';
      newTitle += paramsType;
      if (self.params.destination && self.params.destination != 'default') {
        newTitle += self.params.destination;
      } else {
        newTitle += self.getTextsFromConfig('destinations')
      }
      if (self.params.city && self.params.city != 'default') newTitle += " - " + self.params.city;
      newTitle += mainMetaTitleStatic;
      setPageTitle(newTitle);

      // meta description
      let newDescription = '';
      newDescription += mainMetaDescriptionSearchBefore + paramsType;
      if (self.params.destination && self.params.destination != 'default') {
        newDescription += self.params.destination;
      } else {
        newDescription += self.getTextsFromConfig('destinations')
      }
      if (self.params.city && self.params.city != 'default') newDescription += " - " + self.params.city;
      newDescription += mainMetaDescriptionSearchAfter;
      setMeta("description", newDescription);
    },
    changeParams: function (params) {
      for (let property in this.params) {
        if (this.params.hasOwnProperty(property)) {
          if (params.hasOwnProperty(property)) {
            this.params[property] = params[property];
          }
        }
      }
    },
    setParamsFromGet: function () {
      const self = this;

      for (let property in self.params) {
        if (property == 'type') {
          continue;
        }
        if (self.params.hasOwnProperty(property)) {
          if (self.$route.query.hasOwnProperty(property)) {
            if (self.$route.query[property] != "") {
              if (typeof self.params[property] === 'object') {
                self.params[property] = [];
                if (typeof self.$route.query[property] === 'object') {
                  Object.keys(self.$route.query[property]).forEach(function (key) {
                    self.params[property].push(self.$route.query[property][key]);
                  });
                } else {
                  self.params[property].push(self.$route.query[property]);
                }
              } else {
                if ($.isArray(self.config[property])) {
                  let tmp = [];
                  $.each(self.config[property], function (index, value) {
                    tmp.push(value.value);
                  });
                  if ($.inArray(self.$route.query[property].toString(), tmp) == -1) {
                    continue;
                  }
                }
                self.params[property] = self.$route.query[property];
              }
            }
          }
        }
      }
      self.changeTitleAndDescription();

      if (firstLoad === true) {
        firstLoad = false;
        self.clickSearch(false);
      }
    },
    pushParamsToGet: function () {
      const self = this;
      let query = {};
      for (let property in this.params) {
        if (this.params.hasOwnProperty(property)) {
          if (self.params[property] !== 'default' && self.params[property]) {
            // bez "default"
            query[property] = self.params[property];
          }
        }
      }
      router.replace({
        name: 'search',
        query: query
      }).catch(function (err) { });
    },
    createDatePicker: function (i_max, i) {
      const self = this;
      if ($('body #start_date')[0] && $('body #end_date')[0]) {
        setTimeout(function () {
          $('.input-daterange').datepicker({
            format: "dd.mm.yyyy",
            language: lang,
            autoclose: true,
            startDate: "dateToday",
            datesDisabled: self.config.soldout_days
          }).on('changeDate', function (e) {
            self.params[e.target.id] = e.target.value;
          });
        }, 300);

      } else if (i < i_max) {
        let timeForTimeout = 200 + (Math.pow(i, 3) * 8);
        setTimeout(function () {
          ++i;
          self.createDatePicker(i_max, i);
        }, timeForTimeout);
      }
    },
    refreshSearch: function () {
      const self = this;
      if (self.$route.query.type !== undefined && self.$route.query.type != "") {
        self.params.type = self.$route.query.type;
      }
      serverBus.$emit('loading_start');
      $.post("/back/search/SearchConfig.php", { type: self.params.type }, function (result, textStatus) {
        self.config.show = result.config.show;
        if (result.config.showMw !== undefined && result.config.showMw !== null) self.config.showMw = result.config.showMw;
        self.config.limit = result.limit;
        self.config.hotelNames = result.hotel_names;
        self.params.start_date = result.start_date;
        self.params.end_date = result.end_date;
        self.params.days = result.day;

        self.config.types = [];
        if (result.types !== undefined && result.types !== null) {
          for (let j = 0, len = result.types.length; j < len; j++) {
            self.config.types.push(result.types[j]);
          }
        }

        self.tmp.destinationsAndCities = [];
        if (result.destination !== undefined && result.destination !== null) {
          for (let j = 0, len = result.destination.length; j < len; j++) {
            self.tmp.destinationsAndCities.push(result.destination[j]);
          }
          self.config.destinations = [];
          for (let j = 0, len = result.destination.length; j < len; j++) {
            self.config.destinations.push(result.destination[j]);
          }
          if (self.config.show['destination_city']) {
            self.config.destinations.sort(function (a, b) {
              return ('' + a.text).localeCompare(b.text);
            });
          }
        }

        self.config.adults = [];
        if (result.adults !== undefined && result.adults !== null) {
          for (let j = 0, len = result.adults.length; j < len; j++) {
            self.config.adults.push(result.adults[j]);
          }
        }

        self.config.childrens = [];
        if (result.childrens !== undefined && result.childrens !== null) {
          for (let j = 0, len = result.childrens.length; j < len; j++) {
            self.config.childrens.push(result.childrens[j]);
          }
        }

        self.config.days = [];
        for (let j = 0, len = result.days.length; j < len; j++) {
          self.config.days.push(result.days[j]);
        }

        self.config.transport = [];
        for (let j = 0, len = result.transport.length; j < len; j++) {
          self.config.transport.push(result.transport[j]);
        }

        if (result.mw !== undefined && result.mw !== null) {
          self.config.mw = [];
          for (let j = 0, len = result.mw.length; j < len; j++) {
            self.config.mw.push(result.mw[j]);
          }
        }

        let isAA = false;
        self.config.alimentation = [];
        if (result.alimentation !== undefined && result.alimentation !== null) {
          for (let j = 0, len = result.alimentation.length; j < len; j++) {
            if (result.alimentation[j].value === 'AA') isAA = true;
            else if (!isAA && result.alimentation[j].value === '') result.alimentation[j].value = 'AA';
            self.config.alimentation.push(result.alimentation[j]);
          }
        }

        self.config.age_child_1 = [];
        if (result.age_child_1 !== undefined && result.age_child_1 !== null) {
          for (let j = 0, len = result.age_child_1.length; j < len; j++) {
            self.config.age_child_1.push(result.age_child_1[j]);
          }
        }

        self.config.age_child_2 = [];
        if (result.age_child_2 !== undefined && result.age_child_2 !== null) {
          for (let j = 0, len = result.age_child_2.length; j < len; j++) {
            self.config.age_child_2.push(result.age_child_2[j]);
          }
        }

        self.config.age_child_3 = [];
        if (result.age_child_3 !== undefined && result.age_child_3 !== null) {
          for (let j = 0, len = result.age_child_3.length; j < len; j++) {
            self.config.age_child_3.push(result.age_child_3[j]);
          }
        }

        self.config.age_child_4 = [];
        if (result.age_child_4 !== undefined && result.age_child_4 !== null) {
          for (let j = 0, len = result.age_child_4.length; j < len; j++) {
            self.config.age_child_4.push(result.age_child_4[j]);
          }
        }

        self.config.attributes = [];
        if (result.attributes !== undefined && result.attributes !== null) {
          Object.keys(result.attributes).forEach(function (key) {
            self.config.attributes.push(result.attributes[key]);
          });
        }

        self.config.stars = [];
        if (result.stars !== undefined && result.stars !== null) {
          for (let j = 0, len = result.stars.length; j < len; j++) {
            self.config.stars.push(result.stars[j]);
          }
        }

        self.setParamsFromGet();
        if (self.config.show['destination_city']) self.changeCities('default');
        serverBus.$emit('loading_end');

        self.createDatePicker(10, 0);

      }, "json").fail(function () {
        serverBus.$emit('loading_end');
        self.createDatePicker(10, 0);
        serverBus.errorReturn('search', 2);
      });
    },
    changeCities: function (destination) {
      const self = this;
      self.config.cities = [];
      for (let j = 0, len = self.tmp.destinationsAndCities.length; j < len; j++) {
        if (self.tmp.destinationsAndCities[j].value == destination || destination == 'default') {
          for (let i = 0, len2 = self.tmp.destinationsAndCities[j].cities.length; i < len2; i++) {
            if (config['components']['search']['cityAs'] == 'select') {
              self.config.cities.push(self.tmp.destinationsAndCities[j].cities[i]);
            } else {
              self.config.cities.push(self.tmp.destinationsAndCities[j].cities[i].value);
            }
          }
        }
      }
      self.config.cities.sort(function (a, b) {
        return ('' + a.text).localeCompare(b.text);
      });
    },
    clickSearch: function (manual) {
      if (flagClickSearchWaiting === false) {
        flagClickSearchWaiting = true;
        if (manual) {
          this.pushParamsToGet();
          store.commit('searchParams', this.params);
        }
        this.config.offset = 0;
        this.searchOffers(this.params, this.config)
        window.scrollTo(0, 0);
      }
    },
    showSelectAgeChildrens: function (how_much) {
      const self = this;
      for (let i = 1; i <= 4; i++) {
        if (how_much >= i) {
          self.config.show['age_child_' + i] = true;

        } else {
          self.config.show['age_child_' + i] = false;
          self.params['age_child_' + i] = '';

        }
      }
    },
    clickShowAdvanced: function () {
      this.config.showAdvanced = true;
    },
    clickHideAdvanced: function () {
      this.config.showAdvanced = false;
    },
    searchOffers: function (params, config) {
      const self = this;

      serverBus.$emit('loading_start');
      serverBus.$emit('search_clear');
      serverBus.errorReturn('search', 0);

      self.params.lastKeySeen = '';
      self.params.allIdChecked = '';

      $.post("/back/search/Search.php", { params: params, limit: config.limit, offset: config.offset }, function (result, textStatus) {
        let canonicalGET = '';
        if (Object.keys(result.items).length) {
          let queryDict = {};

          location.search.substring(1).split("&").forEach((item) => { 
            queryDict[item.split("=")[0]] = item.split("=")[1];
          });

          if (queryDict['destination']) {
            canonicalGET += 'destination=' + queryDict['destination'];

            if (queryDict['city']) {
              if (canonicalGET) canonicalGET += '&';
              canonicalGET += 'city=' + queryDict['city'];
            }
          }

          if (canonicalGET) canonicalGET = '?' + canonicalGET;
        }
        setCanonicalTag('https://' + location.host + '/oferty' + canonicalGET);

        serverBus.$emit('search_done', { result: result, params: params });

        if (typeof result.lastKeySeen !== "undefined" && result.lastKeySeen !== null) {
          self.params.lastKeySeen = result.lastKeySeen;
        }

        if (typeof result.allIdChecked !== "undefined" && result.allIdChecked !== null) {
          self.params.allIdChecked = result.allIdChecked;
        }

        serverBus.$emit('loading_end');
        flagClickSearchWaiting = false;

      }, "json").fail(function () {
        serverBus.errorReturn('search', 2);
        flagClickSearchWaiting = false;
        serverBus.$emit('loading_end');
      });
    },
    moreOffers: function () {
      const self = this;
      let newOffset = parseInt(self.config.limit) + parseInt(self.config.offset);

      serverBus.$emit('loading_start');

      $.post("/back/search/Search.php", { params: self.params, limit: self.config.limit, offset: newOffset }, function (result, textStatus) {
        serverBus.errorReturn('search', 0);
        serverBus.$emit('search_done', { result: result, params: self.params });
        self.config.offset = newOffset;
        if (typeof result.lastKeySeen !== "undefined") {
          self.params.lastKeySeen = result.lastKeySeen;
        }
        if (typeof result.allIdChecked !== "undefined" && result.allIdChecked !== null) {
          self.params.allIdChecked = result.allIdChecked;
        }
        serverBus.$emit('loading_end');

      }, "json").fail(function () {
        serverBus.$emit('loading_end');
        serverBus.errorReturn('search', 3);
      });
    },
    getTextsFromConfig: function (key) {
      const self = this;
      let texts = '';
      if (typeof self.config[key] !== "undefined" && self.config[key].length > 0) {
        for (let i = 0; i < self.config[key].length; i++) {
          if (i) texts += ", ";
          texts += self.config[key][i].text;
        }
      }
      return texts;
    },
    showMoreToggle: function (e, sm) {
      if (typeof sm === 'undefined') sm = false;
      const el = e.target.closest((sm) ? '.show-more-div-sm' : '.show-more-div');

      if (el) {
        if (el.dataset.completelyVisible === 'true') {
            el.dataset.completelyVisible = 'false';
            el.classList.add("show-more");
            el.classList.remove("hide-more");
            document.querySelector(".show-more-btn").innerHTML = "Rozwiń";
            el.style.height = '';
        } else {
            const showMoreContent = el.querySelector('.show-more-content');
            const newHeight = showMoreContent.offsetHeight + 32; // (+ wysokosc przycisku)
            el.dataset.completelyVisible = 'true';
            document.querySelector(".show-more-btn").innerHTML = "Zwiń";
            el.style.height = el.offsetHeight + 'px'; 
            el.style.height = newHeight + 'px';
            el.classList.add("hide-more");
            el.classList.remove("show-more");
        }
      }
    }
  }
});

function convertDate(inputFormat) {
  function pad(s) {
    return (s < 10) ? '0' + s : s;
  }
  const d = new Date(inputFormat);
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('.');
}
